import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=d41fe9c2&scoped=true&"
import script from "./DownloadList.vue?vue&type=script&lang=js&"
export * from "./DownloadList.vue?vue&type=script&lang=js&"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=d41fe9c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41fe9c2",
  null
  
)

export default component.exports